import { put, call } from "redux-saga/effects";
import { performGetRequest } from "../../services/apiServices/AxiosUtils";
import { URLS } from "../../services/apiServices/service";

//-----------------------------------------------------------------------------------
export const getJaldiAspectsApi = function* getJaldiAspectsDataApi(action) {
  
  yield put({ type: "SHOW_LOADER" });
  let path = action.path;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

//-----------------------------------------------------------------------------------
export const getJaldiLabNotesApi = function* getJaldiLabNotesDataApi(action) {
  
  yield put({ type: "SHOW_LOADER" });
  let path = action.path;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

//-----------------------------------------------------------------------------------
export const getJaldiLabDetailApiCall = function* getJaldiLabDetailApiCallData(action) {
  
  yield put({ type: "SHOW_LOADER" });

  let path = URLS.JALDILABNOTES + `${action.id}/`;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

//-----------------------------------------------------------------------------------
export const getCollaboratorsListApi = function* getCollaboratorsListApiDataApi(action) {
  
  yield put({ type: "SHOW_LOADER" });
  let path = action.path;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

//-----------------------------------------------------------------------------------
export const getOrganisationListApi = function* getOrganisationListDataApi(action) {
  
  yield put({ type: "SHOW_LOADER" });
  let path = action.path;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBackOrganisation(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

//-----------------------------------------------------------------------------------
export const getJaldiLabProjectListApi = function* getJaldiLabProjectListDataApi(action) {
  
  yield put({ type: "SHOW_LOADER" });
  let path = action.path;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};
//-----------------------------------------------------------------------------------
export const getJaldiLabProjectDetailApi = function* getJaldiLabProjectDetail(action) {
  
  yield put({ type: "SHOW_LOADER" });

  let path = URLS.JALDIPROJECTLIST + `${action.id}/`;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

export const getJaldiLabCourtDesignVideoApi =

  function* getJaldiLabCourtDesignVideo(action) {

    yield put({ type: "SHOW_LOADER" });



    let path = action.path;

    try {

      const res = yield call(performGetRequest, path);

      if ((res !== undefined && res.status === 200) || "success") {

        yield action.successCallBack(res);

        yield put({ type: "HIDE_LOADER" });

      } else if (res.data.status === "error") {

        yield put({ type: "HIDE_LOADER" });

      }

    } catch (error) {

      yield put({ type: "HIDE_LOADER" });

    }

  };

//-----------------------------------------------------------------------------------

export const getJaldiLabDetailedProjectVideoApi =

  function* getJaldiLabDetailedProjectVideo(action) {

    yield put({ type: "SHOW_LOADER" });



    let path = action.path;

    try {

      const res = yield call(performGetRequest, path);

      if ((res !== undefined && res.status === 200) || "success") {

        yield action.successCallBack(res);

        yield put({ type: "HIDE_LOADER" });

      } else if (res.data.status === "error") {

        yield put({ type: "HIDE_LOADER" });

      }

    } catch (error) {

      yield put({ type: "HIDE_LOADER" });

    }

  };
